@if (paymentLoading == false) {
  <div class="v-pad grid-container">
    @if (payment != null) {
      <div class="grid-x">
        <div class="cell small-12">
          <h2>{{payment.description}}</h2>
        </div>
        @if (payment.paymentDate) {
          <div class="cell small-10">
            <h5>{{payment.paymentDate | date}} | {{payment.paymentStatus}}</h5>
          </div>
        }
        <div class="cell small-2">
          <button class="button tiny" (click)="download()">{{ (payment.receipt || payment.queuedReceipt) ? 'Download Receipt' : 'Download Invoice' }}</button>
        </div>
        <div class="cell small-12 border-bottom"></div>
      </div>
      <div class="grid-x">
        <div class="cell small-5">
          <h4>Payment Details</h4>
        </div>
        <div class="cell small-4">
          <span>Application #: {{payment.applicationNumber}}</span>
        </div>
        <div class="cell small-3">
          <span>Payment #: {{payment.id}}</span>
        </div>
        @if (payment.paymentStatus !== 'Paid') {
          <div class="cell small-2">
            <span><label>Status </label>{{payment.paymentStatus}}</span>
          </div>
        }
        <div class="cell small-4">
          <span><label>Amount Paid </label>{{payment.amountPaid | currency: 'USD':'symbol':'1.2-2'}}</span>
        </div>
        <div class="cell small-3">
          <span><label> Outstanding Balance</label> {{payment.amountDue | currency: 'USD':'symbol':'1.2-2'}}</span>
        </div>
        <div class="cell small-3">
          <label>Payment Type </label><span [innerHTML]="token"></span>
        </div>
        <div class="cell small-12">
          <span><label>Purpose </label>{{payment.applicationType}}</span>
        </div>
      </div>
    } @else {
      <div class="grid-x">
        <div class="cell large-12 medium-12 small-12">
          No payment matching the provided criteria has been found.
        </div>
      </div>
    }
  </div>
} @else {
  <div class="v-pad grid-container">
    <div class="grid-x">
      <div class="cell large-12 medium-12 small-12">
        <text-loader [run]="true" [text]="'Loading'" [tickType]="'.'" [interval]="1000"></text-loader>
      </div>
    </div>
  </div>
}



